/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */

function Praktisch() {
  return (
    <div>
      <div className="box light">
        <div className="row">
          <h1>Auto rijden in Costa Rica</h1>
          <p>
            Rijd rustig en plan ruim: ook op doorgaande wegen zitten flinke gaten en verkeersdrempels die lang niet altijd worden aangekondigd. Op de snelweg kun je onverwacht
            fietsers tegenkomen en op kleinere wegen lopen of liggen soms dieren. Het verkeer rond San José is druk en er wordt veel getoeterd, maar verder goed te doen. Rijden in
            het donker wordt terecht afgeraden: het wordt rond 18.00 uur donker, de wegen zijn niet overal goed verlicht en regen maakt het extra lastig. Een 4x4 is vooral in de
            bergen en op steile, smalle wegen een fijne keuze. Zorg ten slotte voor werkende navigatie en bereikbaarheid; een eSIM bleek daarbij erg handig.
          </p>

          <h1>Kleding</h1>
          <p>
            Neem altijd een poncho mee en kies zoveel mogelijk voor sneldrogende kleding. Door de warmte en hoge luchtvochtigheid blijft kleding vaak lang nat of klam; op sommige
            plekken droogt zelfs een waslijn nauwelijks. Een wasservice met droger is daarom erg prettig. Voor wandelingen zijn goede, waterdichte schoenen verstandig: na regen kan
            een pad flink modderig zijn of deels onder water staan. Bij een schildpaddentocht in Tortuguero is bovendien donkere kleding vereist.
          </p>

          <h1>Regenseizoen</h1>
          <p>
            Regen hoort in het regenseizoen erbij, maar is door de warme temperatuur meestal vooral verkoelend. Aan de westkust valt de bui vaak in de middag; aan de oostkust is
            het moment minder voorspelbaar. Buien kunnen plotseling opkomen en weer verdwijnen, dus vertrouw niet te veel op een precieze weersverwachting. Bescherm camera's en
            andere elektronica goed en plan bij voorkeur voldoende tijd in: in de regen is fotograferen en filmen lastig.
          </p>

          <h1>Eten en drinken</h1>
          <p>
            In een lokale soda – een eenvoudig Costa Ricaans restaurantje – kun je prima iets eten of drinken. In hotels en lodges kregen we vaak vers fruit, fruitsap en een
            verzorgd ontbijt; de keuze aan maaltijden kan op afgelegen plekken wel beperkt zijn. Vegetarische opties zijn niet overal vanzelfsprekend, dus kijk vooraf naar het menu
            of neem wat snacks mee. Supermarkten hebben soms vegetarische producten, maar die kunnen behoorlijk duur zijn.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Praktisch;
